import React from 'react';

import Image from 'next/image';
import { useTheme } from 'styled-components';
import Tooltip from 'antd/es/tooltip';

import { InfoIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import { RatingViewModel } from '@api/models/RatingViewModel';
import { Typography } from '@components/Typography';

import { getRating, getRatingAboveFour } from './utils';
import {
  Container,
  MainTitle,
  Note,
  NoteWrapper,
  Percent,
  PercentWrapper,
  ScoringLine,
  ScoringWrapper,
  Separate,
  SpanWrapper,
  TooltipContainer,
  TooltipTitle,
  TotalContainer,
  TotalPercent,
  Wrapper,
  WrapperTitle,
} from './styled';

export type ScoringProps = {
  totalScoring?: number;
  reviews?: RatingViewModel;
};

const ScoringBanner = ({ totalScoring, reviews }: ScoringProps) => {
  const { palette } = useTheme();
  return (
    <Container>
      <Wrapper>
        <Tooltip
          zIndex={10}
          getPopupContainer={(triggerNode) => triggerNode}
          styles={{
            body: {
              backgroundColor: palette.white,
              color: palette.darkGray,
              lineHeight: 1.43,
              width: '250px',
              marginLeft: '-50px',
              minHeight: '260px',
              marginTop: '0',
              borderRadius: '8px',
              boxShadow:
                '0 3px 6px -4px rgba(0,0,0,.12), 0 6px 16px 0 rgba(0,0,0,.08), 0 9px 28px 8px rgba(0,0,0,.05)',
            },
          }}
          showArrow={false}
          placement='bottomRight'
          title={
            <>
              <TotalContainer>
                <TooltipTitle>
                  <MainTitle>Genel Toplam</MainTitle>
                </TooltipTitle>
                <ScoringLine>
                  <Image
                    src={reviews?.rating?.image || ''}
                    alt='playstoreqr'
                    width={60}
                    height={10}
                  />
                </ScoringLine>
                <PercentWrapper>
                  <TotalPercent>{reviews?.rating?.value}/5</TotalPercent>
                </PercentWrapper>
              </TotalContainer>
              {reviews?.rating?.subratings?.map((item) => (
                <div key={item.key}>
                  <TooltipContainer>
                    <TooltipTitle>{item.localizedName}</TooltipTitle>
                    <ScoringLine>
                      <Image
                        src={item?.image || ''}
                        alt='playstoreqr'
                        width={50}
                        height={10}
                      />
                    </ScoringLine>
                    <PercentWrapper>
                      <Percent>{item.value}/5</Percent>
                    </PercentWrapper>
                  </TooltipContainer>
                </div>
              ))}
              <Separate />
              <NoteWrapper>
                <Image
                  src='/static/images/tripadvisor.png'
                  width={18}
                  height={12}
                  alt='Tripadvisor'
                />
                <Note>
                  Otel puanı hiçbir müdahale olmaksızın Tripadvisor’dan
                  alınmaktadır.
                </Note>
              </NoteWrapper>
            </>
          }
        >
          <ScoringWrapper>
            <WrapperTitle>
              <Typography variant='caption3' weight='Regular'>
                Misafir Puanı
              </Typography>
              <Typography variant='caption3' weight='Bold'>
                {getRating(totalScoring ?? 0)}
              </Typography>
            </WrapperTitle>
            <SpanWrapper colorRating={getRatingAboveFour(totalScoring ?? 0)}>
              <CustomIcon icon={InfoIcon} paletteColor='white' fontSize={14} />
              <Typography variant='caption3' weight='SemiBold' color='white'>
                {totalScoring}/5
              </Typography>
            </SpanWrapper>
          </ScoringWrapper>
        </Tooltip>
      </Wrapper>
    </Container>
  );
};
export default ScoringBanner;
